module.exports = __webpack_public_path__ + "img/7corazon.c8475b53.png";